import styled from 'styled-components';

export const LoginContainer = styled.div`
    position: absolute;
    left: 12%;
    top: 32%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1rem;
    color: #84848D;
    width: 20rem;
`;